<span class="label">
    <span
        *ngIf="prefix"
        class="label-prefix"
    >
        {{prefix}}
    </span>
    <span
        *ngIf="text"
        class="label-text"
    >
        {{text}}
    </span>
    <span
        *ngIf="suffix"
        class="label-suffix"
    >
        {{suffix}}
    </span>
</span>
